import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
// Dependencies
import qs from 'query-string';

// TODO: pull this from @nerdwallet/nw-api-sdk instead of defining it here

/**
 * Utility module for fetching data from the data URL
 */
export function fetch(_ref) {
  var url = _ref.url,
    _ref$requestParams = _ref.requestParams,
    requestParams = _ref$requestParams === void 0 ? {} : _ref$requestParams,
    _ref$queryParams = _ref.queryParams,
    queryParams = _ref$queryParams === void 0 ? {} : _ref$queryParams,
    _ref$method = _ref.method,
    method = _ref$method === void 0 ? 'GET' : _ref$method,
    nwApiSdk = _ref.nwApiSdk;
  var ServiceSDK = nwApiSdk.ServiceSDK;
  var params = _objectSpread({}, queryParams);
  return new Promise(function (res, rej) {
    ServiceSDK.http({
      url: "".concat(url, "?").concat(qs.stringify(params, {
        strict: false
      })),
      encoding: 'utf8',
      method: method,
      timeout: 1000,
      // 99% of requests are <= 200 ms.
      body: requestParams,
      json: true,
      callback: function callback(err, resp, body) {
        if (err || resp && resp.statusCode !== 200) {
          // Invoke the callback
          rej(err || resp.body);
          return;
        }
        res(body);
      }
    });
  });
}
export function fetchSuggestions(_ref2) {
  var searchTerm = _ref2.searchTerm,
    nwApiSdk = _ref2.nwApiSdk,
    searchServicesBaseUri = _ref2.searchServicesBaseUri;
  var url = "".concat(searchServicesBaseUri, "/v2/suggest");
  return fetch({
    url: url,
    queryParams: {
      query: searchTerm
    },
    nwApiSdk: nwApiSdk
  });
}